module.exports = __webpack_public_path__ + "static/logo-sm-light-bb02c2c510bf1f9a15d3d389d4c61ead.svg";